const lang = document.documentElement.lang.slice(0, 2); //TO DO
const wpmTexts = require('../constants/texts/' + lang + '.js').wpmTexts
export {wpmTexts}